import { useSearchParams } from 'react-router-dom'

import EmbedWrapper from '@src/pages/Embed/EmbedWrapper'
import FiatExchange from '@src/pages/FiatExchange'

const EmbedExchangePage = () => {
    const [searchParams] = useSearchParams()

    // Parse URL parameters that are specific to this page
    // You could add Exchange-specific parameters here

    return (
        <EmbedWrapper>
            <FiatExchange />
        </EmbedWrapper>
    )
}

export default EmbedExchangePage
